<template>
  <div class="languages-menu">
    <a
      v-for="lang in languages"
      @click="$emit('input', lang.value)"
      :class="{ active: lang.value == value }"
      :key="$id(lang.name)"
      >{{ lang.name }}</a
    >
  </div>
</template>

<script>
export default {
  name: "LanguagePicker",
  props: ["value"],
  data: function () {
    return {
      languages: [
        {
          name: "cURL",
          value: "shell",
        },
        {
          name: "Python",
          value: "python",
        },
        {
          name: "Node",
          value: "node",
        },
      ],
    };
  },
};
</script>
